import { createSlice } from '@reduxjs/toolkit';

const initialState = false;

const errorStateSlice = createSlice({
	name: 'errorState',
	initialState,
	reducers: {
		setErrorState: (state, action) => {
			return action.payload;
		}
	}
});

export const { setErrorState } = errorStateSlice.actions;

export default errorStateSlice.reducer;
